<template>
    <div>
        <div class="main-right" id="main-right" :style="{height: (getWinHeight-60) + 'px'}">
            <!-- <div class="third-nav" v-if="pay_channel_type==2">
                 <div class="third-nav-t">账单列表</div>
             </div>-->
            <!-- tab按钮 start -->
            <!--<div class="third-nav" v-else-if="pay_channel_type==1">-->
            <div class="third-nav">
                <el-menu :default-active="tabIndex" class="el-menu-demo" mode="horizontal" @select="tabSelect">
                    <el-menu-item v-for="(ele,i) in tabList" :key="i" :index="ele.value">{{ele.label}}</el-menu-item>
                </el-menu>
            </div>
            <!-- tab按钮 end -->
            <div class="main-content" id="main-content" :style="{height: (getWinHeight-120)+'px'}">
                <div class="main-feature">
                    <div class="main-inner">
                        <!-- 搜索条件 start -->
                        <el-form :inline="true" ref="postData" :model="postData" class="demo-form-inline">
                            <el-form-item label="日期">
                                <!--:default-time="['12:00:00']"-->
                                <el-date-picker @change="changeDate" v-model="postData.date" type="datetimerange"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>
                            <!--<el-form-item label="门店名">
                                <el-select v-model="postData.store_name" placeholder="门店名">
                                    <el-option v-for="item in shopList"
                                               :key="item.id"
                                               :label="item.value"
                                               :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>-->
                            <el-form-item label="门店名 / 收银员">
                                <el-cascader
                                        @change="choShop"
                                        separator=" "
                                        :options="shopList"
                                        :props="{ checkStrictly: true ,value: 'id',label:'value'}"
                                        clearable></el-cascader>
                            </el-form-item>
                            <el-form-item label="订单号">
                                <el-input v-model="postData.order_no" placeholder="请输入订单号" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="订单状态">
                                <el-select v-model="postData.status" placeholder="订单状态" clearable>
                                    <el-option v-for="item in orderState"
                                               :key="item.value"
                                               :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="收银员">
                                 <el-select v-model="postData.username" placeholder="收银员">
                                     <el-option v-for="item in cashierList"
                                                :key="item.id"
                                                :label="item.value"
                                                :value="item.id"></el-option>
                                 </el-select>
                             </el-form-item>-->
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit" size="small" v-loading="searchState">查询
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onExport" size="small" v-loading="searchState">导出
                                </el-button>
                            </el-form-item>
                        </el-form>
                        <!-- 搜索条件 end -->
                        <div>
                            <el-tooltip class="item" effect="light" content="筛选时间不超过24小时则会显示日交接班数据"
                                        placement="bottom-start" popper-class="popper-tip">
                                <el-tag>日交接班数据 ?</el-tag>
                            </el-tooltip>
                            <template v-if="dayData">
                                <el-tag effect="plain" style="margin-left:20px">交易金额：{{dayData}} &nbsp;&nbsp;
                                    交易笔数：{{pagination.total}}
                                </el-tag>
                            </template>
                        </div>
                        <!-- 表格 start -->
                        <template>
                            <el-table ref="multipleTable" :data="tableData" style="width: 100%;min-width: 780px;"
                                      @selection-change="handleSelectionChange">
                                <el-table-column prop="create_time" label="交易时间">
                                </el-table-column>
                                <el-table-column prop="order_no" label="订单号">
                                </el-table-column>
                                <el-table-column prop="received_price" label="实收金额(元)">
                                </el-table-column>
                                <el-table-column prop="store_name" label="门店名">
                                </el-table-column>
                                <el-table-column prop="user_name" label="收银员">
                                </el-table-column>
                                <el-table-column prop="status" label="订单状态">
                                </el-table-column>
                                <el-table-column label="操作" min-width='50'>
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="refund(scope.row)">退款</el-button>
                                        <el-button type="text" @click="refresh(scope.row)">刷新</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                        <!-- 表格 end -->

                        <el-dialog title="退款" :visible.sync="dialogFormVisible">
                            <el-form :model="form" ref="form" :rules="rules" :label-width="formLabelWidth">
                                <el-form-item label="退款金额" prop="refund_amount">
                                    <el-input v-model="form.refund_amount" placeholder="请输入退款金额"></el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible = false; form.refund_amount = ''">取 消</el-button>
                                <el-button type="primary" @click="confirmClick('form')" v-loading="submitState" :disabled="submitState">确 定</el-button>
                            </div>
                        </el-dialog>

                        <template>
                            <div class="block" style="text-align: center;margin-top: 30px;">
                                <el-pagination @size-change="handleSizeChange"
                                               @current-change="jumpPagination"
                                               @prev-click="prevClick"
                                               @next-click="nextClick"
                                               :current-page="pagination.currentPage"
                                               :page-sizes="pagination.pageCount"
                                               :page-size="pagination.pageSize"
                                               layout="total, sizes, prev, pager, next, jumper"
                                               :total="pagination.total">
                                </el-pagination>
                            </div>
                        </template>

                    </div>
                </div>
                <common-footer></common-footer>
            </div>
        </div>
    </div>
</template>

<script>
    // import second_nav from '../../components/second-nav.vue'
    import CommonFooter from '../../components/CommonFooter.vue'
    const map = {1:'已支付',2:'未支付', 3:'已退款', 4:'订单关闭'};//订单状态
    let reg = /^\d+(\.\d{1,2})?$/; //两位小数，金额
    export default {
        name: "list",
        components: {
            // second_nav,
            CommonFooter
        },
        computed: {
            getWinHeight: function () {
                return this.$winHeight;
            }
        },
        data: function () {
            //退款金额
            var checkMoneyNull = (rule, value, callback) => {
                console.log(typeof this.money,typeof value);
                if (!reg.test(value)|| + value > + this.money || value == 0){
                    callback(new Error(rule.message));
                } else {
                    callback();
                }
            };
            return {
                dayData: null,
                submitState: false,//确认退款按钮状态
                is_can_refund: '',//是否开通退款功能【0:未开通 1已开通】
                money: '',//退款订单-实收金额暂存
                dialogFormVisible: false,
                form: {
                    order_no: '',
                    refund_amount: ''
                },
                formLabelWidth: '120px',
                rules: {
                    refund_amount: [
                        {
                            validator: checkMoneyNull,
                            required: true,
                            message: '请输入正确的退款金额，大于0且小于实收金额',
                            trigger: 'blur'
                        },
                    ]
                },
                pay_channel_type: '',//通道【1：直连；2：间连】
                unlink: true,
                searchState: false,
                date: new Date(),
                //页面所需
                "pagination": {
                    "total": 0,
                    "pageCount": [10, 20, 50, 100],
                    "currentPage": 1,
                    "pageSize": 10,
                    "show": '1-5'
                },
                //接口参数
                "postData": {
                    "cursor": 1,//当前第几页-游标
                    "size": 10,//每页条数
                    "begin_time": '',
                    "end_time": '',
                    "store_name": '',
                    "order_no": '',
                    "username": '',
                    "status": '',
                    "date": [],
                    "pay_method": '1',//【1-支付宝，2-微信】
                },
                choShops: {},//选择的店铺
                choCashier: {},//选择的收银员
                tabIndex: '1',//tab选中值
                tabList: [
                    {
                        value: '1',
                        label: '支付宝'
                    },
                    {
                        value: '2',
                        label: '微信'
                    }
                ],
                shopList: [],
                orderState: [
                    {
                        value: '1',
                        label: '已支付'
                    },
                    {
                        value: '2',
                        label: '未支付'
                    },
                    // {
                    //     value: '3',
                    //     label: '已退款'
                    // }，
                    // {
                    //     value: '4',
                    //     label: '订单关闭'
                    // }
                ],
                cashierList: [
                    {
                        value: '1',
                        label: '小二'
                    }
                ],
                tableData: [],
            }
        },
        methods: {
            /**
             *  选择时间
             */
            changeDate(val) {
                console.log(val, this.postData.date);
                if (val) {
                    let start = new Date(val[0]), end = new Date(val[1]);
                    console.log(start, end);
                    this.postData.begin_time = start.valueOf();
                    this.postData.end_time = end.valueOf();
                    console.log()
                } else {
                    this.postData.begin_time = this.postData.end_time = '';
                }
                console.log(this.postData)
            },
            /**
             * tab选择
             * @param key
             * @param keyPath
             */
            tabSelect(key, keyPath) {
                this.tabIndex = key;
                this.postData.pay_method = key;
                console.log(key, keyPath, this.tabIndex);
                this.pagination.currentPage = this.postData.cursor = 1;
                this.postData.size = 10;
                //this.postData.begin_time = this.postData.end_time = this.postData.date =''
                this.postData.store_name = this.postData.order_no = this.postData.username = this.postData.status ='';
                this.getData();
            },
            /**
             * 分页跳转【当前页】
             */
            jumpPagination(val) {
                console.log(val);
                this.pagination.currentPage = this.postData.cursor = val;
                // this.postData.cursor = val;
                this.getData();
            },
            /**
             * 上一页
             */
            prevClick() {
                this.pagination.currentPage--;
                this.postData.cursor--;
                this.getData();
            },
            /**
             * 下一页
             */
            nextClick() {
                this.pagination.currentPage++;
                this.postData.cursor++;
                this.getData();
            },
            /**
             * 每页条数
             * @param val
             */
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagination.size = this.postData.size = val;
                this.getData();
            },
            /**
             * 获取门店list
             */
            getShopData() {
                //初始化列表
                this.$axios.post('/mer/order/choose/store').then(res => {
                    console.log(res);
                    if (res.data.code === this.$webConfig.httpSuccessStatus) {
                        this.shopList = res.data.data;
                        this.shopList.forEach((item, index) => {
                            // this.shopList[index].cities = [] // 视图未更新
                            this.$set(this.shopList[index], 'children', []) // right
                        })
                    } else {
                        this.$message(res.data.message);
                    }
                })
                    .catch(() => {

                    });
            },
            /**
             *  选择门店
             */
            choShop(val) {
                console.log(val);
                if (val.length == 0) {
                    this.postData.store_name = '';
                    this.postData.username = '';
                    console.log(this.postData);
                } else if (val.length == 1) {
                    this.postData.store_name = val[0];
                    console.log(this.postData);
                } else if (val.length == 2) {
                    this.postData.username = val[1];
                    console.log(this.postData);
                }
                if (val != []) {
                    let value = val[0];
                    this.$axios.post('/mer/order/choose/cashier', {
                        'store_id': value
                    }).then((res) => {
                        let children = res && res.data && res.data.data || [];
                        for (let i = 0; i < this.shopList.length; i++) {
                            if (this.shopList[i].id === value) {
                                this.$set(this.shopList[i], 'children', children);
                                break;
                            }
                        }
                    })
                }
                console.log(this.postData);
            },
            timestampToTime(timestamp) {
                var date = new Date(timestamp);
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + ' ';
                // var h = date.getHours() + ':';
                // var m = date.getMinutes() + ':';
                // var s = date.getSeconds();
                //return Y + M + D + h + m + s;
                return Y + M + D;
            }
            ,
            /**
             * 数据导出
             */
            onExport() {
                this.searchState = true;
                let api = '';
                if (this.pay_channel_type == 1) {
                    if (this.tabIndex == 1) {
                        api = '/mer/order/ali/face/pay/list/export'
                    } else {
                        api = '/mer/order/wx/face/pay/list/export'
                    }
                } else if (this.pay_channel_type == 2) {
                    api = '/mer/order/lkl/face/pay/list/export'
                }
                //初始化列表
                this.$axios.post(api, this.postData, {responseType: 'blob'}).then(res => {
                    console.log(res.data.type);
                    let __that = this;
                    let resType = res.data.type;
                    if (resType == "application/json") {
                        let reader = new FileReader();
                        reader.readAsText(res.data, 'utf-8');
                        reader.onload = function () {
                            let resDta = JSON.parse(reader.result);
                            __that.$message({type: 'info', message: resDta.message});
                        };
                    }

                    if (resType == "bin") {
                        const blob = new Blob([res.data]);
                        const fileName = this.timestampToTime(this.postData.date[0].valueOf()) + '订单明细.csv';
                        if ('download' in document.createElement('a')) { // 非IE下载
                            const elink = document.createElement('a')
                            elink.download = fileName
                            elink.style.display = 'none'
                            elink.href = URL.createObjectURL(blob)
                            document.body.appendChild(elink)
                            elink.click()
                            URL.revokeObjectURL(elink.href) // 释放URL 对象
                            document.body.removeChild(elink)
                        } else { // IE10+下载
                            navigator.msSaveBlob(blob, fileName)
                        }
                    }
                    this.searchState = false;
                })
                    .catch(() => {
                        this.searchState = false;
                    });
            }
            ,
            /**
             * 获取列表数据
             */
            getData() {
                console.log(this.postData);
                let api = '';
                if (this.pay_channel_type == 1) {
                    if (this.tabIndex == 1) {
                        api = '/mer/order/ali/face/pay/list'
                    } else {
                        api = '/mer/order/wx/face/pay/list'
                    }
                } else if (this.pay_channel_type == 2) {
                    api = '/mer/order/lkl/face/pay/list'
                }
                console.log(this.postData, api);
                //初始化列表
                this.$axios.post(api, this.postData).then(res => {
                    console.log(res);
                    if (res.data.code === this.$webConfig.httpSuccessStatus) {
                        this.tableData = res.data.data.data.face_pay_order_resps;
                        this.dayData = res.data.data.data.sum_received_price;
                        this.tableData.forEach(ele => {
                            ele.status = map[ele.status];
                            ele.create_time = new Date(ele.create_time).format('yyyy-MM-dd hh:mm:ss');
                        });
                        console.log(this.tableData);
                        this.pagination.total = res.data.data.count;
                        this.pagination.currentPage = res.data.data.cursor;
                    }
                    this.searchState = false;
                })
                    .catch(() => {
                        this.searchState = false;
                    });
            }
            ,
            /**
             * 查询
             */
            onSubmit() {
                console.log('submit!');
                this.searchState = true;
                this.pagination.currentPage = this.postData.cursor = 1;
                this.getData();
            }
            ,
            open() {
                this.$confirm('确定删除此商品吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
            ,
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            /**
             *  退款
             */
            refund(data){
                console.log(data);
                this.money = data.received_price;
                //获取是否退款
                this.$axios.get('/mer/getIsCanRefund').then(res => {
                    console.log('获取是否退款',res);
                    if (res.data.code == this.$webConfig.httpSuccessStatus) {
                        this.is_can_refund = res.data.data.is_can_refund;
                        if(this.is_can_refund==1){
                            this.dialogFormVisible = true;
                            this.form.order_no = data.order_no;
                        }else {
                            this.$message.warning('商家未开通退款权限');
                        }
                    } else {
                        this.$message(res.data.message);
                    }
                })
                    .catch((rej) => {
                        console.log('错误',rej);
                        this.$message('网络异常!');
                    });
                /*this.$message({
                    type: 'info',
                    message: '暂未开通，请联系客服开通退款功能'
                });*/
            },
            /**
             *  确认退款
             */
            confirmClick(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitState = true;
                        this.$axios.post('/mer/refundOrder', this.form).then(res => {
                            console.log('确认退款', res);
                            if (res.data.code == this.$webConfig.httpSuccessStatus) {
                                if(res.data.data.code == 'SUCCESS') {
                                    this.$message.success('退款成功');
                                    this.form.refund_amount = '';
                                    this.dialogFormVisible = false;
                                    this.getData();
                                    this.submitState = false;
                                }else {
                                    this.$message(res.data.data.msg);
                                    this.submitState = false;
                                }
                            } else {
                                this.$message(res.data.message);
                                this.submitState = false;
                            }
                        })
                            .catch((rej) => {
                                console.log('错误', rej);
                                this.$message('网络异常!');
                                this.submitState = false;
                            });
                    } else {
                        return false;
                    }
                })
            },
            /**
             * 刷新某账单
             */
            refresh(data) {
                console.log(data);
                //刷新某订单
                this.$axios.post('/mer/order/checkOrder', {"order_no": data.order_no}).then(res => {
                    console.log('刷新列表', res);
                    if (res.data.code === this.$webConfig.httpSuccessStatus) {
                        this.$message({type: 'info', message: '刷新成功'});
                        this.getData();
                    } else {
                        this.$message(res.data.message);
                    }
                })
                    .catch((rej) => {
                        console.log('错误', rej);
                        this.$message('网络异常!');
                    });
            }
        },
        created() {
            this.pay_channel_type = this.$ls.get(this.$webConfig.pay_channel_type)
        }
        ,
        beforeMount() {
            //默认日期
            let nowDate = new Date();
            let today = nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + nowDate.getDate() + '';
            nowDate.setDate(nowDate.getDate() + 1);
            let tomorrow = nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + nowDate.getDate() + '';
            this.postData.date = [today, tomorrow];
            this.postData.begin_time = new Date(today).valueOf();
            this.postData.end_time = new Date(tomorrow).valueOf();

            // 获取列表数据
            this.getData();
            //    获取门店list
            this.getShopData();

        }
        ,
    }
</script>


<style scoped>
    .el-date-editor--datetimerange {
        width: 230px !important;
        margin-top: 4px;
    }

    >>> .popper-tip {
    }
</style>
